import React from 'react';
import { InferGetServerSidePropsType, GetServerSideProps, GetServerSidePropsResult } from 'next';
import Head from 'next/head';
import { Container } from '@goodrx/matisse';
import { startCase } from 'lodash';
import http from 'app/lib/http';
import Markdown from 'app/components/core/markdown';
import { MarketingLayout } from 'app/components/marketing/MarketingLayout';
import { NextPageProps } from 'app/types/NextPageProps';
import { getServices } from 'app/data/staticPropsCommon/services';
import { HttpStatusCodes } from 'app/types';

interface LegalPageProps extends NextPageProps {
  code: string;
  document: string;
}

const LegalPage = ({ code, document, services }: InferGetServerSidePropsType<typeof getServerSideProps>) => (
  <MarketingLayout services={services} canonicalLink={null}>
    <Head>
      <title>{startCase(code)}</title>
      <meta name="robots" content="noindex" />
    </Head>

    <Container mt={5}>
      <Markdown source={document} />
    </Container>
  </MarketingLayout>
);

export const getServerSideProps: GetServerSideProps<LegalPageProps> = async (
  ctx
): Promise<GetServerSidePropsResult<LegalPageProps>> => {
  const { code } = ctx.query as { code: string };

  const document = await http
    .get(`/legals/${code}`)
    .then(({ data }) => data)
    .catch(() => {
      throw new Error(HttpStatusCodes.NotFound);
    });

  return {
    props: {
      code,
      document,
      services: await getServices(),
    },
  };
};

export default LegalPage;
